import createEnum from 'scripts/lib/create_enum';

var UserCredentialType = createEnum('ACTIVATION_TOKEN', 'PASSWORD', 'RESET_PASSWORD_TOKEN');

export default UserCredentialType;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/user_credential_type.js